import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getTenantBranding } from "../../api/api";
import logo from "../../assets/dental logo.webp";
import call from "../../assets/footer/calling.png";
import location from "../../assets/footer/location.png";
import time from "../../assets/footer/time.png";
import "./Footer.scss";

const Footer = () => {
  const [tenantInfo, setTenantInfo] = useState(null);

  useEffect(() => {
    const fetchTenantInfo = async () => {
      try {
        const brandingData = await getTenantBranding();
        console.log(brandingData);
        setTenantInfo(brandingData);
      } catch (error) {
        console.error('Error fetching tenant info:', error);
      }
    };

    fetchTenantInfo();
  }, []);

  const footerMenu = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "About Us",
      link: "/about",
    },
    {
      name: "Dental Services",
      link: "/services",
    },
    {
      name: "Contact Us",
      link: "/contact",
    },
    // {
    //   name: "Blogs",
    //   link: "/blogs",
    // },
    //   {
    //     name: "FAQs",
    //     link: "/",
    //   },
  ];

  const footerContacts = [
    {
      title: "Phone Number",
      info: Array.isArray(tenantInfo?.phone_number) 
        ? tenantInfo.phone_number.join(' , ') 
        : tenantInfo?.phone_number || "+088 123 654 987",
      icon: call,
    },
    {
      title: "Open Hour",
      info: tenantInfo?.clinic_timing?.full_timing || "09:00 AM - 18:00 PM",
      icon: time,
    },
    {
      title: "Clinic Address",
      info: tenantInfo?.address || "Mavdi chowk, near ashirwad hospital, opp jitriya Hanuman temple mavdi rajkot - 360004",
      icon: location,
    },
  ];

  return (
    <footer className="pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-5">
            <div className="footer-logo">
              <img src={logo} alt="logo" height="50" width="50" />
            </div>
            <p>
              {tenantInfo?.name ? `${tenantInfo.name} is a top-rated local practice for cosmetic, preventative, and restorative dentistry.` : 'Dental Care Seattle is a top-rated local practice for cosmetic, preventative, and restorative dentistry on First Hill'}
            </p>

            {/* <div className="social-logo">
              <p>Follow us on</p>
              <ul>
                <li>
                  <a href="/">
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a href="/">
                    <FaTwitter />
                  </a>
                </li>
                <li>
                  <a href="/">
                    <FaInstagram />
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
          <div className="col-lg-2 col-md-2">
            <div className="footer-link">
              <p>Quick Links</p>
              <ul>
                {footerMenu.map((singleMenu, index) => (
                  <li key={singleMenu.link || index}>
                    <Link
                      onClick={() => window.scrollTo(0, 0)}
                      to={singleMenu.link}
                    >
                      {singleMenu.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-5">
            <div className="footer-contact">
              <p>Contact & Information</p>

              {footerContacts.map((footerContact, index) => {
                return (
                  <div key={footerContact.title || index} className="contact-list">
                    <div className="contact-icon">
                      <img src={footerContact.icon} alt="call" />
                    </div>
                    <div className="contact-text">
                      <p>{footerContact.title}</p>
                      <h5>{footerContact.info}</h5>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="copyright-area">
  <div className="copy-text">
    <p>
      &copy;{" "}
      <a
        href="https://technoscaffold.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white decoration-none"
      >
        Technoscaffold AI & IT Solutions
      </a>. All Rights Reserved.
    </p>
  </div>
</div>

      </div>
    </footer>
  );
};

export default Footer;
